module.exports = "/assets/data/5fa2a38d4dab1290d02ccc5aa01655e0-G74.data.json";